import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { DataTableColumn } from '../../../shared/ui/data-table/data-table.component';
import { SellerService, ManagerService } from '../../../core';
import { PopupMessageService } from '../../../shared/message/services/message.service';

@Component({
  selector: 'app-approval-tracker-modal',
  templateUrl: './approval-tracker-modal.component.html',
  styleUrls: ['./approval-tracker-modal.component.scss']
})
export class ApprovalTrackerModalComponent implements OnChanges {
  @Input() triggerChallenge: any = null;
  @Output() closed = new EventEmitter<void>();

  @ViewChild('atStatusTpl') atStatusTpl!: TemplateRef<any>;
  @ViewChild('atDateTpl') atDateTpl!: TemplateRef<any>;
  @ViewChild('atCommentsTpl') atCommentsTpl!: TemplateRef<any>;

  isModalOpen = false;
  approvalTrackerData: any[] = [];
  approvalTrackerChallengeData: any = null;
  approvalTrackerResendSpinner = false;
  approvalTrackerApprovalType: any;
  approvalTrackerTableColumns: DataTableColumn[] = [];
  isApprovalRowExpanded = (row: any) => row.comments != null;

  resendApprovalData: any = null;
  resendApprovalFlag = false;
  resendApprovalSendMailToNotifyee = false;

  constructor(
    private managerService: ManagerService,
    private sellerService: SellerService,
    private popupMessageService: PopupMessageService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['triggerChallenge'] && changes['triggerChallenge'].currentValue) {
      this.loadAndOpen(changes['triggerChallenge'].currentValue);
    }
  }

  private loadAndOpen(val: any) {
    const param = 'customChallengeId=' + val.id;
    this.managerService.getApprovalData(param).subscribe((data: any[]) => {
      if (data.length > 0) {
        data.forEach((elm: any) => {
          elm.id = val.id;
        });
      }
      this.approvalTrackerData = data;
      this.approvalTrackerChallengeData = val;
      this.isModalOpen = true;
      setTimeout(() => { this.buildApprovalTrackerColumns(); });
    });
  }

  closeModal() {
    this.isModalOpen = false;
    this.approvalTrackerChallengeData = null;
    this.resendApprovalData = null;
    this.approvalTrackerResendSpinner = false;
    this.closed.emit();
  }

  approvalTrackerResendLink(val: any) {
    this.approvalTrackerApprovalType = val.type;
    this.approvalTrackerResendSpinner = true;
    this.resendApprovalData = val;
    this.resendApprovalFlag = false;
    this.resendApprovalSendMailToNotifyee = false;
  }

  closeResendApprovalModal() {
    this.resendApprovalData = null;
    this.approvalTrackerResendSpinner = false;
  }

  sendResendApprovalLink(type: string) {
    this.resendApprovalFlag = true;
    const reqParam = 'customChallengeId=' + this.resendApprovalData.id
      + '&approvalType=' + type
      + '&notifyPassiveRecipients=' + this.resendApprovalSendMailToNotifyee;
    this.sellerService.resendApprovalLink(reqParam).subscribe(
      (data: any) => {
        if (data) {
          this.resendApprovalFlag = false;
          this.resendApprovalData = null;
          this.popupMessageService.showSuccess('Approval Link sent successfully', 'success');
          setTimeout(() => {
            this.approvalTrackerResendSpinner = false;
            this.closeModal();
          }, 1000);
        }
      },
      (err: any) => {
        if (err.status === '412 - PRECONDITION_FAILED' || err.status === '409 - CONFLICT') {
          this.popupMessageService.showError(err.msg, 'error');
        }
        this.resendApprovalData = null;
        this.approvalTrackerResendSpinner = false;
      }
    );
  }

  isInactiveChallenge(): boolean {
    if (this.approvalTrackerChallengeData && this.approvalTrackerChallengeData.status == 'INACTIVE') {
      return true;
    }
    return false;
  }

  trackByIndex(index: number): number {
    return index;
  }

  private buildApprovalTrackerColumns() {
    this.approvalTrackerTableColumns = [
      { field: 'approverEmail', header: 'APPROVER EMAIL', align: 'left' },
      { field: 'status', header: 'STATUS', align: 'left', cellTemplate: this.atStatusTpl },
      { field: 'date', header: 'EXPIRY / RESPONDED ON', align: 'left', cellTemplate: this.atDateTpl }
    ];
  }
}
